export default __webpack_public_path__ + "static/media/coresanscr45-webfont.8e0069e2.woff";